import React from 'react';
import { Divider } from './Divider';

function hashString(str: string): string {
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
        const char = str.charCodeAt(i);
        hash = (hash << 5) - hash + char;
        hash |= 0; // Convert to 32bit integer
    }
    return hash.toString();
}

export function renderTextBlock(text: string) {
    const key = hashString(text);
    const linkRegex = /\[link=(.*?)\|(.*?)\]|\[(.*?)\]\((.*?)\)/g;

    const renderFormattedText = (text: string): React.ReactNode[] => {
        const boldItalicRegex = /\*\*\*(.*?)\*\*\*/g;
        const boldRegex = /\*\*(.*?)\*\*/g;
        const italicRegex = /\*(.*?)\*/g;

        return text
            .split(boldItalicRegex)
            .map((part, index) =>
                index % 2 === 1 ? (
                    <b key={`boldItalic-${index}`}>
                        <i>{part}</i>
                    </b>
                ) : part
            )
            .flatMap((part) =>
                typeof part === 'string'
                    ? part
                          .split(boldRegex)
                          .map((subPart, subIndex) =>
                              subIndex % 2 === 1 ? <b key={`bold-${subIndex}`}>{subPart}</b> : subPart
                          )
                          .flatMap((subPart) =>
                              typeof subPart === 'string'
                                  ? subPart
                                        .split(italicRegex)
                                        .map((subSubPart, subSubIndex) =>
                                            subSubIndex % 2 === 1 ? (
                                                <i key={`italic-${subSubIndex}`}>{subSubPart}</i>
                                            ) : subSubPart
                                        )
                                  : subPart
                          )
                    : part
            );
    };

    const renderLinks = (text: string): React.ReactNode[] => {
        const parts: React.ReactNode[] = [];
        let lastIndex = 0;

        text.replace(linkRegex, (match, p1, p2, p3, p4, offset) => {
            parts.push(renderFormattedText(text.slice(lastIndex, offset)));
            if (p1 && p2) {
                parts.push(
                    <a href={p2} className="a-description-link" target="_blank" rel="noreferrer" key={`link-${offset}`}>
                        {p1}
                    </a>
                );
            } else if (p3 && p4) {
                parts.push(
                    <a href={p4} className="a-description-link" target="_blank" rel="noreferrer" key={`link-${offset}`}>
                        {p3}
                    </a>
                );
            }
            lastIndex = offset + match.length;
            return match;
        });

        parts.push(renderFormattedText(text.slice(lastIndex)));
        return parts;
    };

    const renderTextWithDividers = (text: string): React.ReactNode[] => {
        return text.split('---').flatMap((part, index, array) => {
            const nodes = [<React.Fragment key={`${key}-${index}`}>{renderLinks(part)}</React.Fragment>];
            if (index < array.length - 1) {
                nodes.push(<Divider width={100} key={`${key}-divider-${index}`} />);
            }
            return nodes;
        });
    };

    return <>{renderTextWithDividers(text)}</>;
}